import styled from 'styled-components'

export interface ICardFooterStyledProps {
  hasBorder?: boolean
  isSticky?: boolean
}

export const CardFooterStyled = styled.div<ICardFooterStyledProps>`
  position: relative;
  color: ${(props) => props.theme.colors.text.primary};

  padding: ${(props) =>
    props.theme.box.horizontalPadding(props.theme.typography.htmlFontSize)};

  border-bottom-left-radius: ${(props) =>
    props.theme.box.borderRadius(props.theme.typography.htmlFontSize)};
  border-bottom-right-radius: ${(props) =>
    props.theme.box.borderRadius(props.theme.typography.htmlFontSize)};

  ${({ isSticky, hasBorder, theme }) => {
    if (isSticky) {
      return `
        position: sticky;
        bottom: 0;
        background-color: ${theme.colors.content.contentBackground};
        ${hasBorder ? `border-top: 1px solid ${theme.colors.content.border};` : ''}
      `
    }
  }}
`

CardFooterStyled.displayName = 'CardFooterStyled'
